export interface ResolvedRange {
  start: string | null
  end: string | null
}

function toISODate(d: Date) {
  return d.toISOString().split('T')[0]
}

export function resolvePresetRange(preset: string): ResolvedRange {
  const now = new Date()
  switch (preset) {
    case 'today': {
      const d = toISODate(now)
      return { start: d, end: d }
    }
    case 'yesterday': {
      const y = new Date(now)
      y.setDate(y.getDate() - 1)
      const d = toISODate(y)
      return { start: d, end: d }
    }
    case 'last7days': {
      const end = toISODate(now)
      const startDate = new Date(now)
      startDate.setDate(startDate.getDate() - 6)
      return { start: toISODate(startDate), end }
    }
    case 'last30days': {
      const end = toISODate(now)
      const startDate = new Date(now)
      startDate.setDate(startDate.getDate() - 29)
      return { start: toISODate(startDate), end }
    }
    case 'thismonth': {
      const start = new Date(now.getFullYear(), now.getMonth(), 1)
      const end = new Date(now.getFullYear(), now.getMonth() + 1, 0)
      return { start: toISODate(start), end: toISODate(end) }
    }
    case 'lastmonth': {
      const start = new Date(now.getFullYear(), now.getMonth() - 1, 1)
      const end = new Date(now.getFullYear(), now.getMonth(), 0)
      return { start: toISODate(start), end: toISODate(end) }
    }
    case 'thisyear': {
      const start = new Date(now.getFullYear(), 0, 1)
      const end = new Date(now.getFullYear(), 11, 31)
      return { start: toISODate(start), end: toISODate(end) }
    }
    case 'lastyear': {
      const start = new Date(now.getFullYear() - 1, 0, 1)
      const end = new Date(now.getFullYear() - 1, 11, 31)
      return { start: toISODate(start), end: toISODate(end) }
    }
    default:
      return { start: null, end: null }
  }
}
